(function () {
  'use strict';

  /* =========================================================
     ANEKANTA HERBAL LIBRARY - FILTER / SEARCH / HASH
     ========================================================= */

  var FILTERS = [
    'all',
    'blossoms',
    'leaves',
    'roots',
    'spices',
    'nuts_seeds',
    'whole'
  ];

  function normalize(value) {
    if (!value) return 'all';
    return String(value).trim().toLowerCase().replace(/\s+/g, '_');
  }

  function getHashFilter() {
    var hash = window.location.hash.replace(/^#/, '').trim();
    var filter = normalize(hash);
    return FILTERS.indexOf(filter) !== -1 ? filter : 'all';
  }

  function writeHash(filter) {
    var url = new URL(window.location.href);
    url.hash = filter === 'all' ? '' : filter;
    window.history.replaceState(
      { herbalLibraryFilter: filter },
      '',
      url.toString()
    );
  }

  function initLibrary(library) {
    if (library.dataset.herbalLibraryReady === 'true') return;
    library.dataset.herbalLibraryReady = 'true';

    var buttons = library.querySelectorAll('[data-filter]');
    var cards = library.querySelectorAll('[data-herbal-card]');
    var search = library.querySelector('[data-herbal-search]');
    var count = library.querySelector('[data-result-count]');
    var empty = library.querySelector('[data-empty-state]');

    if (!buttons.length || !cards.length) {
      console.warn('Anekanta Herbal Library: filter elements not found.');
      return;
    }

    var activeFilter = 'all';

    function setActiveButtons(filter) {
      buttons.forEach(function (button) {
        var value = normalize(button.getAttribute('data-filter'));
        var active = value === filter;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function applyFilter(filter, updateUrl) {
      filter = normalize(filter);
      if (FILTERS.indexOf(filter) === -1) filter = 'all';

      activeFilter = filter;

      var term = search ? search.value.trim().toLowerCase() : '';
      var visible = 0;

      cards.forEach(function (card) {
        var category = normalize(card.getAttribute('data-category'));
        var searchable = (card.getAttribute('data-search') || '').toLowerCase();

        var categoryMatch = filter === 'all' || category === filter;
        var searchMatch = !term || searchable.indexOf(term) !== -1;
        var show = categoryMatch && searchMatch;

        card.hidden = !show;
        card.classList.toggle('is-filter-hidden', !show);

        if (show) visible += 1;
      });

      setActiveButtons(filter);

      if (count) {
        count.textContent =
          visible + (visible === 1 ? ' botanical' : ' botanicals');
      }

      if (empty) empty.hidden = visible !== 0;

      if (updateUrl) writeHash(filter);
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        applyFilter(button.getAttribute('data-filter'), true);
      });
    });

    if (search) {
      search.addEventListener('input', function () {
        applyFilter(activeFilter, false);
      });
    }

    window.addEventListener('hashchange', function () {
      applyFilter(getHashFilter(), false);
    });

    window.addEventListener('popstate', function () {
      applyFilter(getHashFilter(), false);
    });

    applyFilter(getHashFilter(), false);
  }

  function init() {
    document.querySelectorAll('[data-herbal-library]').forEach(initLibrary);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();


/* =========================================================
   ANEKANTA HERBAL LIBRARY - MEGA MENU CATEGORY FIX
   ========================================================= */

(function () {
  'use strict';

  var HERBAL_LIBRARY_PATH = '/pages/herbal-library';

  /*
   * IMPORTANT:
   * Do NOT close the menu during the capture phase.
   * Dawn uses its own click handler to control <details>.
   * Closing too early can cause the menu to reopen.
   *
   * This function is called after the click event finishes.
   */
  function closeMegaMenu() {
    document.querySelectorAll(
      'header details[open], .header details[open], details.menu-drawer-container[open]'
    ).forEach(function (details) {
      details.removeAttribute('open');
    });

    document.body.classList.remove(
      'overflow-hidden',
      'menu-opening',
      'overflow-hidden-tablet'
    );

    document.documentElement.classList.remove(
      'overflow-hidden',
      'menu-opening'
    );

    document.querySelectorAll(
      '.mega-menu.is-open, ' +
      '.mega-menu.active, ' +
      '.mega-menu.open, ' +
      '.mega-menu--open, ' +
      '[data-mega-menu].is-open, ' +
      '[data-mega-menu].active, ' +
      '[data-mega-menu].open'
    ).forEach(function (menu) {
      menu.classList.remove(
        'is-open',
        'active',
        'open',
        'mega-menu--open'
      );
      menu.removeAttribute('open');
    });

    document.querySelectorAll(
      '.menu-drawer, .drawer, .header__submenu'
    ).forEach(function (element) {
      element.classList.remove('is-open', 'active', 'open');
    });

    document.querySelectorAll(
      'header summary[aria-expanded="true"], ' +
      'header button[aria-expanded="true"], ' +
      'header a[aria-expanded="true"]'
    ).forEach(function (element) {
      element.setAttribute('aria-expanded', 'false');
    });
  }

  function getCategoryFromURL(url) {
    return (url.hash || '').replace(/^#/, '').toLowerCase();
  }

  function applyLibraryCategory(category) {
    if (!category) return;

    var buttons = document.querySelectorAll('[data-filter]');

    buttons.forEach(function (button) {
      var value = String(
        button.getAttribute('data-filter') || ''
      ).trim().toLowerCase();

      if (value === category) {
        button.click();
      }
    });
  }

  /*
   * Use normal/bubble click phase.
   * This is the key fix for Dawn mega-menu reopening.
   */
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-herbal-category-link]');

    if (!link) return;

    var href = link.getAttribute('href');
    if (!href) return;

    var targetURL;

    try {
      targetURL = new URL(href, window.location.origin);
    } catch (error) {
      return;
    }

    if (targetURL.pathname !== HERBAL_LIBRARY_PATH) return;

    var category = getCategoryFromURL(targetURL);

    /*
     * Already on Herbal Library:
     * stop normal anchor navigation, update hash/filter,
     * then close the menu AFTER Dawn has processed the click.
     */
    if (window.location.pathname === HERBAL_LIBRARY_PATH) {
      event.preventDefault();

      var currentURL = new URL(window.location.href);
      currentURL.hash = category || '';

      window.history.replaceState(
        { herbalLibraryFilter: category || 'all' },
        '',
        currentURL.toString()
      );

      /*
       * Let Dawn finish its own menu click first.
       */
      setTimeout(function () {
        applyLibraryCategory(category);
        closeMegaMenu();

        /*
         * Second pass protects against delayed theme handlers.
         */
        setTimeout(closeMegaMenu, 60);
      }, 0);

      return;
    }

    /*
     * Coming from another page:
     * allow normal navigation. The destination page reads #hash.
     * Just close any open state after the event.
     */
    setTimeout(closeMegaMenu, 0);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeMegaMenu();
    }
  });

  /*
   * Shopify Theme Editor / section reload support.
   */
  document.addEventListener('shopify:section:load', function () {
    setTimeout(function () {
      if (window.location.pathname !== HERBAL_LIBRARY_PATH) return;

      var category = (window.location.hash || '')
        .replace(/^#/, '')
        .toLowerCase();

      if (category) {
        applyLibraryCategory(category);
      }
    }, 0);
  });
})();


/* =========================================================
   ANEKANTA GLOBAL LINK HARD-RELOAD FIX
   ---------------------------------------------------------
   Purpose:
   - Force a real browser page load for internal links.
   - Ensures Dawn mega-menu completely resets on navigation.
   - Also reloads when clicking a link to the SAME page.
   - Hash/category links such as #blossoms still work.
   - External links, javascript links, downloads, buttons,
     forms and special browser links are left untouched.
   ========================================================= */

(function () {
  'use strict';

  function shouldHardReload(link, event) {
    if (!link) return false;

    /*
     * Ignore modified clicks:
     * Ctrl/Cmd = new tab
     * Shift = new window
     * Alt = download/save behavior
     */
    if (
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return false;
    }

    /*
     * Only normal left mouse click.
     */
    if (
      event.type === 'click' &&
      event.button !== 0
    ) {
      return false;
    }

    /*
     * Do not interfere with download links.
     */
    if (link.hasAttribute('download')) {
      return false;
    }

    var href = link.getAttribute('href');

    if (!href) return false;

    href = href.trim();

    /*
     * Ignore special links.
     */
    if (
      href === '' ||
      href === '#' ||
      href.indexOf('javascript:') === 0 ||
      href.indexOf('mailto:') === 0 ||
      href.indexOf('tel:') === 0
    ) {
      return false;
    }

    /*
     * Ignore anchors used as UI controls.
     */
    if (
      link.hasAttribute('data-no-hard-reload') ||
      link.hasAttribute('data-no-reload')
    ) {
      return false;
    }

    /*
     * Ignore links which explicitly open a new target.
     */
    var target = link.getAttribute('target');

    if (
      target &&
      target !== '_self'
    ) {
      return false;
    }

    /*
     * Ignore external domains.
     */
    var url;

    try {
      url = new URL(
        href,
        window.location.href
      );
    } catch (error) {
      return false;
    }

    if (
      url.origin !==
      window.location.origin
    ) {
      return false;
    }

    return true;
  }


  function hardNavigate(link) {
    var href = link.getAttribute('href');

    if (!href) return;

    var url = new URL(
      href,
      window.location.href
    );

    /*
     * Close Dawn menu state before navigation.
     * The actual browser navigation then completely
     * rebuilds the header and mega-menu from scratch.
     */
    document
      .querySelectorAll(
        'header details[open], ' +
        '.header details[open], ' +
        'details.menu-drawer-container[open]'
      )
      .forEach(function (details) {
        details.removeAttribute('open');
      });

    document.body.classList.remove(
      'overflow-hidden',
      'menu-opening',
      'overflow-hidden-tablet'
    );

    document.documentElement.classList.remove(
      'overflow-hidden',
      'menu-opening'
    );

    /*
     * IMPORTANT:
     * location.href performs a normal full document
     * navigation. It is NOT SPA/AJAX navigation.
     *
     * Therefore Dawn header + mega menu are rebuilt.
     */
    if (
      url.href ===
      window.location.href
    ) {
      /*
       * Same exact URL:
       * force a complete refresh.
       */
      window.location.reload();
    } else {
      /*
       * Different internal URL:
       * normal full page navigation.
       */
      window.location.href =
        url.href;
    }
  }


  /*
   * Use capture phase so Shopify/Dawn's own delegated
   * navigation cannot turn this into a partial interaction.
   */
  document.addEventListener(
    'click',
    function (event) {

      var link =
        event.target.closest('a[href]');

      if (
        !shouldHardReload(
          link,
          event
        )
      ) {
        return;
      }

      /*
       * Keep normal modified clicks untouched.
       */
      event.preventDefault();
      event.stopPropagation();

      /*
       * Stop other click handlers on the same element.
       */
      if (
        typeof event.stopImmediatePropagation ===
        'function'
      ) {
        event.stopImmediatePropagation();
      }

      hardNavigate(link);

    },
    true
  );

})();
